const branchIdentifier = process.env.REACT_APP_BRANCH_IDENTIFIER || 'master';
const apiBranchIdentifier = `use1-${branchIdentifier}`;
const appConfig = process.env.REACT_APP_CONFIG || 'nonprod';
const deploymentVersion = process.env.REACT_APP_DEPLOYMENT_VERSION || '';
const isProd = (appConfig !== 'nonprod');

const useCdn = isProd || branchIdentifier === 'master';
const internalDomainName = isProd ? 'awskbbeditorialwidgets.kbb.com' : 'awskbbeditorialwidgetsnp.kbb.com';
const cdnBaseUrl = isProd ? 'https://sew.syndication.kbb.com' : 'https://sewnp.syndication.kbb.com';
const apiBaseUrl = `https://use1-${branchIdentifier}.${internalDomainName}`;
const baseUrl = useCdn ? cdnBaseUrl : apiBaseUrl;
const devBaseUrl = 'https://dev.awskbbeditorialwidgetsnp.kbb.com/';

const commonConfig: Record<string, string | boolean> = {
  apiBranch: apiBranchIdentifier,
  appConfig,
  baseUrl,
  branchIdentifier,
  cdnBaseUrl,
  apiBaseUrl,
  devBaseUrl,
  deploymentVersion,
  useCdn,
};

export default commonConfig;
